import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Select } from 'antd';
import { getProducts } from '../../../services/offers/products';

const ProductList = ({
  value,
  onChange,
  userTypesIds,
  showOnlyPasses = false,
}) => {
  const [content, setContent] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const results = await Promise.all(
          userTypesIds.map((userTypeId) =>
            getProducts({
              criterias: {
                deleted: false,
                userTypeId,
                page: 0,
                size: 10000,
                ...(showOnlyPasses ? { category: 'PASS' } : {}),
              },
            }),
          ),
        );

        setContent(results.map((res) => res.content).flat());
      } catch (error) {
        console.error('Error fetching products:', error);
      }
    };
    if (userTypesIds) {
      fetchData();
    }
  }, [userTypesIds, showOnlyPasses]);

  const internalValue = useMemo(() => {
    return (value || '')
      .split(',')
      .map((v) => parseInt(v, 10))
      .filter(Number.isInteger);
  }, [value]);

  const handleChange = useCallback(
    (val) => {
      onChange(Array.isArray(val) ? val.join(',') : '');
    },
    [onChange],
  );

  return (
    <Select
      mode="multiple"
      allowClear
      value={internalValue}
      onChange={handleChange}
      showSearch
      optionFilterProp="children"
    >
      {content &&
        content.map(({ id, name }) => (
          <Select.Option key={id} value={id}>
            {name}
          </Select.Option>
        ))}
    </Select>
  );
};

export default ProductList;
